const features = [
  'Viga e IPR estructural',
  'Varilla corrugada y malla electrosoldada',
  'Tubo negro y galvanizado',
  'Ángulos y soleras',
  'Lámina para techo, negra y antiderrapante',
  'PTR y cuadros',
  'Placas de acero',
  'Moiten y canal',
  'Alambre recocido',
  'Consumibles y ferretería',
];

export default function About() {
  return (
    <section id="nosotros" className="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-text-col">
            <span className="about-badge">⚙ Quiénes Somos</span>
            <h2 className="about-title">
              Tu Distribuidora de Acero<br />
              de Confianza en <span>Jalostotitlán</span>
            </h2>
            <p className="about-text">
              Aceros Jalos es el punto de referencia para profesionales de la
              construcción y la metalmecánica en la región. Ubicados estratégicamente
              sobre la Carretera a San Juan Bosco en Jalostotitlán, con más de una
              década de experiencia abastecemos proyectos de toda envergadura —
              desde pequeñas reparaciones hasta grandes obras.
            </p>
            <p className="about-text">
              Manejamos distintos tipos de calidad según los requerimientos de cada
              cliente: contamos con el material adecuado para herrería, metalmecánica
              y construcción estructural, siempre con servicio personalizado y precios justos.
            </p>

            <div className="about-features">
              {features.map((f) => (
                <div key={f} className="about-feature">
                  <span className="about-feature-dot" />
                  {f}
                </div>
              ))}
            </div>
          </div>

          <div className="about-visual">
            <div className="about-stats-box">
              <div className="about-stat">
                <span className="about-stat-number">+10</span>
                <span className="about-stat-label">Años en el mercado</span>
              </div>
              <div className="about-stat">
                <span className="about-stat-number">+500</span>
                <span className="about-stat-label">Clientes atendidos</span>
              </div>
              <div className="about-stat">
                <span className="about-stat-number">10+</span>
                <span className="about-stat-label">Líneas de producto</span>
              </div>
              <div className="about-stat">
                <span className="about-stat-number">100%</span>
                <span className="about-stat-label">Compromiso local</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
